import { render, staticRenderFns } from "./ProductPromotion.vue?vue&type=template&id=cbc0922c&scoped=true"
import script from "./ProductPromotion.vue?vue&type=script&lang=js"
export * from "./ProductPromotion.vue?vue&type=script&lang=js"
import style0 from "./ProductPromotion.vue?vue&type=style&index=0&id=cbc0922c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc0922c",
  null
  
)

export default component.exports